// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6908":"css/app.6844","7061":"css/admin-app.6844"}[chunkId] + ".css";
};